<template>
  <main>
    <!-- Campaign general info section -->
    <section class="whiteBox">
      <div class="content">
        <div class="row alignCenter">
          <div>
            <h1>{{this.campaign.name}}&nbsp;</h1>
          </div>

          <div v-if="campaign['status']==0" class="chip grey mR-10">{{$t('campaignStatus.draft')}}</div>
          <div v-if="campaign['status']==1" class="chip green mR-10">{{$t('campaignStatus.active')}}</div>
          <div
            v-if="campaign['status']==2"
            class="chip greyBold mR-10"
          >{{$t('campaignStatus.archived')}}</div>
          <div v-if="campaign['status']==3" class="chip black mR-10">{{$t('campaignStatus.closed')}}</div>
          <div class="row bubbleParent alignCenter alignRight3">
            <button
              v-if="pageRights.retrieveCoupon && campaign['coupon-attribution']"
              @click="displayAssignCoupon = true;"
            >{{$t('addUser.assignCoupons')}}</button>
            <!-- Export button-->
            <div class="bubbleParent">
              <button
                class="outline"
                @click="campaign['campaign-type-global']  ? exportGlobalInfosCSV('campaign_info',campaign,discountsList,null) : exportSubMenu = !exportSubMenu"
                v-if="pageRights.exportCampaign"
              >
                <i class="fas fa-arrow-up rotate"></i>
                {{$t('button.export')}}
              </button>
              <div class="bubble" v-if="exportSubMenu">
                <a
                  @click="exportGlobalInfosCSV('campaign_info',campaign,discountsList,null);"
                >{{$t('button.exportCampaignInfo')}}</a>
                <a
                  @click="exportGlobalInfosCSV('coupon_code',campaign,null,null,couponList) ;"
                >{{$t('button.exportCouponCode')}}</a>
              </div>
            </div>
            <!-- CampaignMenu button -->
            <button
              v-if="pageRights.modifyCampaign"
              ref="mainMenu1"
              class="outline"
              @click="campaingSubMenu=!campaingSubMenu"
            >
              <img
                ref="mainMenu2"
                class="pastille"
                src="@/assets/images/pastille.png"
                alt="pastille"
              />
            </button>
            <div class="bubble" v-if="campaingSubMenu">
              <a
                @click="$router.push({name: 'updateCampaign', params: { id: campaign.id}})"
              >{{$t('campaigns.modifyCampaignAction')}}</a>
              <a
                class="redText"
                v-if="(campaign['status']==0) || (campaign['status'] == 1)"
                @click="prepareArchive(campaign)"
              >{{$t('campaigns.archiveAction')}}</a>
              <a
                v-if="campaign['status']==2"
                @click="archiveCampaign(campaign, 1)"
              >{{$t('campaigns.activateAction')}}</a>
              <a
                class="redText"
                v-if="campaign['status']==2"
                @click="prepareClose(campaign)"
              >{{$t('campaigns.closeAction')}}</a>
            </div>
          </div>
        </div>
        <div class="row">
          <p
            v-if="campaign['campaign-type-global']"
            class="comments"
          >&nbsp;{{$t('campaigns.uniqueCouponCampaign')}}</p>
          <p v-else class="comments">&nbsp;{{$t('campaigns.severalCouponsCampaign')}}</p>
        </div>
        <div class="row">
          <div class="column space"></div>
          <div class="column"></div>
        </div>
        <br />
        <div class="column" style="display: inline-flex;">
          <div class="row" style="align-items:center;">
            <img src="@/assets/images/nb-used-coupons.png" />
            <p style="padding-left:10px;">
              <span
                class="accentuate"
              >{{parseInt(this.campaign['number-of-used-coupons'])+parseInt(this.campaign['number-of-reserved-coupons'])}}/{{this.campaign['max-number-of-coupons']}}</span>
              {{$t('campaigns.usedWith')}}
              <span
                class="accentuate"
              >{{this.campaign['number-of-reserved-coupons']}}</span>
              {{$t('campaigns.inProgress')}}
            </p>
          </div>
          <div class="row" style="align-items:center;">
            <img src="@/assets/images/max-use-by-client.png" />
            <p style="padding-left:10px;">
              <span v-if="campaign['campaign-type-global']" class="accentuate">{{this.couponList[0]["max-number-of-uses-per-client"]}}</span>
              <span v-else class="accentuate">1</span>
              {{$t('campaigns.nbUsesMaxByClient')}}
            </p>
          </div>
          <div v-if="campaign['restricted-use']==1" class="row" style="align-items:center;">
            <img src="@/assets/images/restricted-use.png" />
            <p style="padding-left:10px;">{{$t('campaigns.restrictedUsage')}}</p>
          </div>
        </div>
        <div class="column" style="display: inline-flex;width:40px;"></div>
        <div class="column" style="display: inline-flex;">
          <div class="row" style="align-items:center;" v-if="campaign['start-date']!=null">
            <img src="@/assets/images/start-date.png" />
            <p style="padding-left:10px;">
              {{$t('dateManagement.starts') }}
              <span
                class="accentuate"
              >{{moment(this.campaign['start-date']).format(`DD/MM/YYYY ${$t('dateManagement.at')} HH[${$t('dateManagement.hourSeparator')}]mm`)}}</span>
            </p>
          </div>
          <div class="row" style="align-items:center;" v-if="campaign['expiration-date']!=null">
            <img src="@/assets/images/expiration-date.png" />
            <p style="padding-left:10px;">
              {{$t('dateManagement.expires')}}
              <span
                class="accentuate"
              >{{moment(this.campaign['expiration-date']).format(`DD/MM/YYYY ${$t('dateManagement.at')} HH[${$t('dateManagement.hourSeparator')}]mm`)}}</span>
            </p>
          </div>
          <div class="row" style="align-items:center;" v-if="campaign['coupon-attribution']">
            <img src="@/assets/images/coupon-attribution.png" />
            <p style="padding-left:10px;">{{$t('campaigns.SAVCampaign')}}</p>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-mask" v-if="displayAssignCoupon">
      <section class="modal reduced">
        <AssignCoupons
          v-if="displayAssignCoupon"
          :parCampaignId="this.$route.params.id"
          @close="displayAssignCoupon = false"
        />
      </section>
    </div>
     <ConfirmationBox
      v-if="show.confirm"
      :parData="confirmationData"
      @continueprocess="continueProcess"
      @close="show.confirm=false"
    ></ConfirmationBox>
  </main>
</template>
<script>
import Campaigns from "@/services/Campaigns";
import Coupons from "@/services/Coupons";
import Discounts from "@/services/Discounts";
import generalMethods from "@/mixins/generalMethods";
import getCampaignDetails from "@/mixins/getCampaignDetails";
import bubble from "@/mixins/bubble";
import AssignCoupons from "@/components/coupons/AssignCoupons";
import ConfirmationBox from "@/mixins/ConfirmationBox";
export default {
  props: ["parCampaignId", "parPageRights"],
  mixins: [bubble, getCampaignDetails, generalMethods],
  components: {
    AssignCoupons,
    ConfirmationBox
  },
  data() {
    return {
      displayAssignCoupon: false,
      discountsList: {},
      couponList:[],
      campaign: {},
      pageRights: {},
      exportSubMenu: false
    };
  },
  mounted() {
    this.getCampaignInfoById(this.parCampaignId);
    this.getCouponList(this.parCampaignId);
    this.pageRights = this.parPageRights;
  },
  methods: {
    getCampaignInfoById(id) {
      if (id) {
        Campaigns.getById(id).then(res => {
          if (res.data["number-of-used-coupons"] == null)
            res.data["number-of-used-coupons"] = "0";
          else
            res.data["number-of-used-coupons"] = res.data[
              "number-of-used-coupons"
            ].toLocaleString("fr");

          if (res.data["max-number-of-coupons"] == null)
            res.data["max-number-of-coupons"] = "0";
          else
            res.data["max-number-of-coupons"] = res.data[
              "max-number-of-coupons"
            ].toLocaleString("fr");
          this.campaign = res.data;
          Discounts.getByCampaignId(id).then(res => {
            this.discountsList = res.data;
          });
          //this.checkUserRights();
        });
      }
    },
    getCouponList(id){
      Coupons.getByCampaignId(id).then(res => {
                            if (res.status == 200) {
                                this.couponList = res.data;
                                
                            }
                        });
    }
  }
};
</script>

